import React from "react";
import "../styles/Transaction.css";
import { Link } from 'react-router-dom';
import StatusBadge from "./StatusBadge";




const Transaction = ({ name, amount, date, status,serviceId }) => {
  
  return (
    <li className="transaction-item d-flex justify-content-between align-items-center p-2">
      <div className="transaction-details">
        {/* Changed span to div and removed onClick */}
        {
        /*
        <div className="transaction-name">
        onClick={handleClickForTrxReport(name)}
          {name}
        </div>
       */ }
        <Link
  to={{
    pathname: `/reports`,
  }}
  state={{  srvId: serviceId }}
  className="transaction-name"
>
  {name}
</Link>

        <div className="transaction-date">{date}</div>
      </div>
      <div className="transaction-amount-status text-end">
        {/* <span className="transaction-amount">{amount}</span>
        <span className="transaction-amount-status">{status}</span>
           */}

           <div style={{marginBottom: "4px"}}>
            <span className="transaction-amount">₹{amount}</span>
           </div>
           
            <StatusBadge status={status} />
           
        
      </div>
    </li>
  );
};

export default Transaction;
